(function () {
  'use strict';

  // ─── i18n · locale-aware strings ───
  // Detect locale via Shopify global · fallback to 'it'
  const LOCALE = (() => {
    try {
      const l = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'it';
      return l.toLowerCase().startsWith('en') ? 'en' : 'it';
    } catch (e) { return 'it'; }
  })();

  const QUIZ_STRINGS = {
    it: {
      // shade names (used in result reveal)
      shadeNames: {
        "1N":"Chiaro Naturale","1C":"Chiaro Freddo","2W":"Chiaro Caldo","2N":"Beige Naturale",
        "3N":"Beige Solare","3W":"Dorato Caldo","4W":"Ambrato","4C":"Bronzo Freddo",
        "5W":"Caramello Intenso","6N":"Cioccolato"
      },
      undertoneLabel: {C:"freddo",W:"caldo",N:"neutro"},
      // loader phrases
      loader_p1: "Sto leggendo il tuo sottotono…",
      loader_p1_sub: "12.000+ italiane scelgono Bronzata",
      loader_p2: "Confronto con i tuoi tratti…",
      loader_p2_sub: "97% l'ha comprato di nuovo",
      loader_p3: "Trovata · la tua corrispondenza è pronta",
      loader_p3_sub: "30 giorni soddisfatta o rimborsata",
      // CTA labels
      cta_bundle: "Aggiungi la coppia",
      cta_single: "Aggiungi la mia tonalità",
      cta_bundle_sub: "Pennello Kabuki incluso in regalo",
      cta_single_sub_b6: "Oppure scegli l'abbonamento qui sotto · −15%",
      cta_single_sub: "Pennello Kabuki in regalo se scegli la coppia",
      // Result tag labels
      tag_recommended: "Consigliata per te",
      tag_second_lighter: "Seconda tonalità · giorni meno solari",
      tag_second_tan: "Seconda tonalità · per la te abbronzata",
      tag_for_off_days: "Per i giorni meno solari",
      tag_for_tan_you: "Per la te abbronzata",
      // Pick copy (result rows)
      pick_copy_tan_normal: "Per quando hai la pelle dopo il sole · estate e vacanze.",
      pick_copy_natural_off: "Per quando hai la pelle naturale · inverno e pre-estate.",
      pick_copy_max_dark: "Già al massimo del colore · è anche la tua tonalità abbronzata.",
      pick_copy_lighter_off: "Per i giorni meno solari · un tono più chiaro.",
      pick_copy_lighter_max: "Per il tuo tono naturale · al massimo del colore di pelle.",
      pick_copy_daily: "Per la pelle di tutti i giorni · inverno e pre-estate.",
      extra_copy_lighter: "Per i giorni meno solari · un tono più chiaro per variare.",
      extra_copy_warmer: "Per quando torni dal mare · estate e occasioni.",
      // Bundle why copy
      bundle_why_lighter: "Una tonalità per il tuo tono naturale. Una un passo più chiara per i giorni meno solari · così hai variazione tra le stagioni. Stessa formula, stessa tenuta.",
      bundle_why_warmer: "Una tonalità per la pelle di tutti i giorni. Una un passo più calda — per quando torni dal mare. Stessa formula, stessa tenuta. La pelle resta uniforme tutto l'anno.",
      // Subscription block
      sub_eyebrow_b6: "La tua tonalità · raccomandata in abbonamento",
      sub_head_b6_prefix: "Niente decisioni · ",
      sub_head_b6_suffix: " a casa tua ogni 60 giorni · −15%.",
      sub_eyebrow_default: "L'80% sceglie l'abbonamento",
      sub_head_default: "Perché diventa la tua routine, non un acquisto.",
      // Upsell block
      upsell_head_downshift: "Aggiungi una tonalità più chiara per variare",
      upsell_body_downshift: "La tua tonalità è già al massimo del colore. Una più chiara per i giorni meno solari. Pennello Kabuki in regalo.",
      upsell_head_abbronzata: "La tonalità del sole + una per la pelle naturale",
      upsell_body_abbronzata: "Una per quando hai la pelle naturale, una per quando torni dal mare. Pennello Kabuki in regalo.",
      upsell_head_default: "La tonalità di ogni giorno + una un tono più caldo",
      upsell_body_default: "Una per ufficio, palestra, weekend. Una per quando vuoi sembrare appena tornata dal mare. Pennello Kabuki in regalo.",
      // Remove button aria
      remove_aria: "Rimuovi seconda tonalità",
      remove_title: "Rimuovi"
    },
    en: {
      shadeNames: {
        "1N":"Natural Fair","1C":"Porcelain","2W":"Warm Beige","2N":"Natural Beige",
        "3N":"Sun Beige","3W":"Warm Gold","4W":"Amber","4C":"Bronze",
        "5W":"Deep Caramel","6N":"Chocolate"
      },
      undertoneLabel: {C:"cool",W:"warm",N:"neutral"},
      loader_p1: "Reading your undertone…",
      loader_p1_sub: "12,000+ across Europe choose Bronzata",
      loader_p2: "Matching your features…",
      loader_p2_sub: "97% bought it again",
      loader_p3: "Found · your match is ready",
      loader_p3_sub: "30-day satisfaction guarantee",
      cta_bundle: "Add the duo",
      cta_single: "Add my shade",
      cta_bundle_sub: "Kabuki brush included as gift",
      cta_single_sub_b6: "Or pick the subscription below · −15%",
      cta_single_sub: "Kabuki brush free with the duo",
      tag_recommended: "Recommended for you",
      tag_second_lighter: "Second shade · for less-sunny days",
      tag_second_tan: "Second shade · for your tanned self",
      tag_for_off_days: "For less-sunny days",
      tag_for_tan_you: "For your tanned self",
      pick_copy_tan_normal: "For when your skin's seen the sun · summer and holidays.",
      pick_copy_natural_off: "For your natural skin · winter and pre-summer.",
      pick_copy_max_dark: "Already the deepest shade · this is also your tanned tone.",
      pick_copy_lighter_off: "For less-sunny days · one tone lighter.",
      pick_copy_lighter_max: "Your natural tone · at your skin's max depth.",
      pick_copy_daily: "For everyday skin · winter and pre-summer.",
      extra_copy_lighter: "For less-sunny days · one tone lighter to switch it up.",
      extra_copy_warmer: "For when you're back from the sea · summer and occasions.",
      bundle_why_lighter: "One shade for your natural tone. One a step lighter for less-sunny days · so you have variation across seasons. Same formula, same wear.",
      bundle_why_warmer: "One shade for everyday skin. One a step warmer — for when you're back from the sea. Same formula, same wear. Even skin all year.",
      sub_eyebrow_b6: "Your shade · recommended on subscription",
      sub_head_b6_prefix: "No decisions · ",
      sub_head_b6_suffix: " delivered every 60 days · save 15%.",
      sub_eyebrow_default: "80% choose the subscription",
      sub_head_default: "Because it becomes your routine, not a purchase.",
      upsell_head_downshift: "Add a lighter shade to switch it up",
      upsell_body_downshift: "Your shade is already at max depth. A lighter one for less-sunny days. Kabuki brush included as gift.",
      upsell_head_abbronzata: "The tanned shade + one for natural skin",
      upsell_body_abbronzata: "One for your natural skin, one for when you're back from the sea. Kabuki brush included as gift.",
      upsell_head_default: "The everyday shade + one warmer tone",
      upsell_body_default: "One for office, gym, weekend. One for when you want to look fresh off the beach. Kabuki brush included as gift.",
      remove_aria: "Remove second shade",
      remove_title: "Remove"
    }
  };

  // T(key) helper · returns localized string with IT fallback
  const T = (key) => (QUIZ_STRINGS[LOCALE] && QUIZ_STRINGS[LOCALE][key]) || QUIZ_STRINGS.it[key] || key;

  const data = {
    // PDP variant names · locale-aware (IT default, EN switched at runtime)
    shadeNames: QUIZ_STRINGS[LOCALE]?.shadeNames || QUIZ_STRINGS.it.shadeNames,
    // # variant order on PDP
    shadeNumber: {
      "1N":"1","1C":"1","2W":"2","2N":"2","3N":"3","3W":"3","4W":"4","4C":"4","5W":"5","6N":"6"
    },
    // Flat hex (circular swatch fill)
    shadeHex: {
      "1N":"#F1D8C0","1C":"#EBD0BE","2W":"#E6C29C","2N":"#D9B391","3N":"#C9A180",
      "3W":"#BD9670","4W":"#A07650","4C":"#956B45","5W":"#7C5235","6N":"#5C3C24"
    },
    shadeMatch: {"1":{"C":"1C","W":"2W","N":"1N"},"2":{"C":"2N","W":"2W","N":"2N"},"3":{"C":"3N","W":"3W","N":"3N"},"4":{"C":"4C","W":"4W","N":"4C"},"5":{"C":"5W","W":"5W","N":"5W"},"6":{"C":"6N","W":"6N","N":"6N"}},
    tanShift: {"0":1,"1":1,"2":1,"3":2},
    undertoneLabel: QUIZ_STRINGS[LOCALE]?.undertoneLabel || QUIZ_STRINGS.it.undertoneLabel
  };
  const STEPS = ['q1','q2','q3','q4','result'];
  const PROGRESS_TOTAL = STEPS.length - 1;
  const state = { step:'q1', history:[], answers:{q1:null,q2:null,q3:null,q4:null}, primary:null, secondary:null, upsellAdded:false, stepStartTs: 0, sessionStartTs: 0 };

  // PostHog helper · safe no-op if not loaded
  function track(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props || {});
      }
    } catch (e) {}
  }
  function timeOnStepMs() {
    return state.stepStartTs ? Date.now() - state.stepStartTs : 0;
  }
  // PDP loaded · once
  track('bzf_pdp_loaded', { url: location.pathname });
  const $ = (s,r) => (r||document).querySelector(s);
  const $$ = (s,r) => Array.from((r||document).querySelectorAll(s));
  const modal = $('[data-bzf-modal]');

  function openModal() {
    modal.setAttribute('data-on','');
    document.body.classList.add('is-locked');
    state.sessionStartTs = Date.now();
    state.stepStartTs = Date.now();
    track('bzf_quiz_opened');
    goTo('q1', false);
  }
  function closeModal() {
    const completed = state.step === 'result';
    track('bzf_modal_closed', {
      last_step: state.step,
      completed,
      session_duration_ms: state.sessionStartTs ? Date.now() - state.sessionStartTs : 0,
      answers_filled: Object.values(state.answers).filter(v => v != null).length
    });
    modal.removeAttribute('data-on');
    document.body.classList.remove('is-locked');
    state.history = [];
    state.answers = {q1:null,q2:null,q3:null,q4:null};
    state.primary = state.secondary = null;
    state.upsellAdded = false;
    state.sessionStartTs = 0;
    state.stepStartTs = 0;
    $$('[aria-checked="true"]').forEach(b => b.setAttribute('aria-checked','false'));
  }
  function goTo(step, push) {
    if (!STEPS.includes(step)) return;
    if (push !== false) state.history.push(state.step);
    state.step = step;
    state.stepStartTs = Date.now();
    track('bzf_step_viewed', { step });
    $$('.bzf-step').forEach(s => s.dataset.bzfStep === step ? s.setAttribute('data-active','') : s.removeAttribute('data-active'));
    updateProgress(); updateBackButton();
    if (step === 'result') { renderResult(); }
    const body = $('.bzf-body'); if (body) body.scrollTop = 0;
  }
  function next() {
    const idx = STEPS.indexOf(state.step);
    const nx = STEPS[idx+1]; if (!nx) return;
    if (nx === 'result') {
      computeShades();
      const hasTrue = state.secondary && state.secondary !== state.primary;
      const secLighter = hasTrue && parseInt(state.secondary[0],10) < parseInt(state.primary[0],10);
      track('bzf_quiz_completed', {
        primary: state.primary, secondary: state.secondary,
        q1: state.answers.q1, q2: state.answers.q2, q3: state.answers.q3, q4: state.answers.q4,
        has_true_secondary: hasTrue,
        sec_lighter: secLighter,
        is_bundle_natural: state.answers.q4 === 'entrambe',
        b6_edge: secLighter,
        match_score: 97,
        session_duration_ms: state.sessionStartTs ? Date.now() - state.sessionStartTs : 0
      });
      track('bzf_loader_shown');
      showLoader(() => goTo(nx));
    } else goTo(nx);
  }
  function back() {
    if (state.history.length === 0) return;
    const prev = state.history.pop();
    track('bzf_back_pressed', { from: state.step, to: prev });
    state.step = prev;
    state.stepStartTs = Date.now();
    $$('.bzf-step').forEach(s => s.dataset.bzfStep === prev ? s.setAttribute('data-active','') : s.removeAttribute('data-active'));
    updateProgress(); updateBackButton(); restoreAnswersFor(prev);
    const body = $('.bzf-body'); if (body) body.scrollTop = 0;
  }
  function updateProgress() {
    const fill = $('[data-bzf-progress]');
    const pct = Math.min(100, (STEPS.indexOf(state.step) / PROGRESS_TOTAL) * 100);
    if (fill) fill.style.width = pct + '%';
  }
  function updateBackButton() {
    const btn = $('[data-bzf-back]'); if (!btn) return;
    btn.hidden = state.history.length === 0;
  }
  function restoreAnswersFor(step) {
    const a = state.answers;
    if (step === 'q1' && a.q1 != null) $$('[data-bzf-q1]').forEach(b => b.setAttribute('aria-checked', b.dataset.bucket === a.q1 ? 'true' : 'false'));
    else if (step === 'q2' && a.q2 != null) $$('[data-bzf-q2]').forEach(b => b.setAttribute('aria-checked', b.dataset.undertone === a.q2 ? 'true' : 'false'));
    else if (step === 'q3' && a.q3 != null) $$('[data-bzf-q3]').forEach(b => b.setAttribute('aria-checked', b.dataset.sun === a.q3 ? 'true' : 'false'));
    else if (step === 'q4' && a.q4 != null) $$('[data-bzf-q4]').forEach(b => b.setAttribute('aria-checked', b.dataset.use === a.q4 ? 'true' : 'false'));
  }
  // Loader 6s · 3 USP phases × 2s · then pour-curtain 1.4s transition · then result
  function showLoader(done) {
    const loader = $('[data-bzf-loader]');
    if (!loader) return done && done();
    const copyEl = $('[data-bzf-loader-copy]');
    const subEl = $('[data-bzf-loader-sub]');
    const pour = $('[data-bzf-pour]');
    const sheet = $('[data-bzf-pour-sheet]');

    // Pour color = recommended shade for the user
    const q4 = state.answers.q4;
    const hasTrue = state.secondary && state.secondary !== state.primary;
    const pickCode = (q4 === 'abbronzata' && hasTrue) ? state.secondary : state.primary;
    const pourHex = data.shadeHex[pickCode] || '#C9A180';
    if (sheet) sheet.style.setProperty('--pour-color', pourHex);

    const phases = [
      { copy: T('loader_p1'), sub: T('loader_p1_sub') },
      { copy: T('loader_p2'), sub: T('loader_p2_sub') },
      { copy: T('loader_p3'), sub: T('loader_p3_sub') }
    ];

    loader.setAttribute('data-on','');
    if (pour) pour.removeAttribute('data-on');
    if (pour) pour.classList.remove('is-pouring');

    function setPhase(p) {
      if (copyEl) { copyEl.style.opacity = '0'; setTimeout(() => { copyEl.textContent = p.copy; copyEl.style.opacity = '1'; }, 180); }
      if (subEl)  { subEl.style.opacity = '0';  setTimeout(() => { subEl.textContent = p.sub;  subEl.style.opacity = '1'; }, 180); }
    }

    setPhase(phases[0]);
    const t2 = setTimeout(() => setPhase(phases[1]), 2000);
    const t3 = setTimeout(() => setPhase(phases[2]), 4000);

    // At 6s · trigger pour-curtain · sheet wipes down (0→42% of 1.4s = ~590ms) → cover
    // Mid-sheet (~700ms) swap loader→result · then sheet wipes off bottom (700→1400ms)
    const tPour = setTimeout(() => {
      if (pour) {
        pour.setAttribute('data-on','');
        pour.classList.add('is-pouring');
      }
    }, 6000);

    // ~6750ms: sheet fully covers → swap loader off + render result underneath
    const tSwap = setTimeout(() => {
      loader.removeAttribute('data-on');
      done && done();
    }, 6750);

    // 7500ms: sheet has slid off bottom · cleanup
    setTimeout(() => {
      clearTimeout(t2); clearTimeout(t3); clearTimeout(tPour); clearTimeout(tSwap);
      if (pour) { pour.removeAttribute('data-on'); pour.classList.remove('is-pouring'); }
    }, 7500);
  }

  function pulseAndAdvance(btn, advanceDelay) {
    btn.classList.add('is-pulsing');
    setTimeout(() => btn.classList.remove('is-pulsing'), 600);
    setTimeout(next, advanceDelay);
  }
  $$('[data-bzf-q1]').forEach(b => b.addEventListener('click', () => {
    $$('[data-bzf-q1]').forEach(x => x.setAttribute('aria-checked','false'));
    b.setAttribute('aria-checked','true');
    state.answers.q1 = b.dataset.bucket;
    track('bzf_step_answered', { step: 'q1', value: b.dataset.bucket, time_on_step_ms: timeOnStepMs() });
    if (Object.values(state.answers).filter(v => v != null).length === 1) track('bzf_quiz_started');
    pulseAndAdvance(b, 320);
  }));
  $$('[data-bzf-q2]').forEach(b => b.addEventListener('click', () => {
    $$('[data-bzf-q2]').forEach(x => x.setAttribute('aria-checked','false'));
    b.setAttribute('aria-checked','true');
    state.answers.q2 = b.dataset.undertone;
    track('bzf_step_answered', { step: 'q2', value: b.dataset.undertone, time_on_step_ms: timeOnStepMs() });
    pulseAndAdvance(b, 320);
  }));
  $$('[data-bzf-q3]').forEach(b => b.addEventListener('click', () => {
    $$('[data-bzf-q3]').forEach(x => x.setAttribute('aria-checked','false'));
    b.setAttribute('aria-checked','true');
    state.answers.q3 = b.dataset.sun;
    track('bzf_step_answered', { step: 'q3', value: b.dataset.sun, time_on_step_ms: timeOnStepMs() });
    pulseAndAdvance(b, 320);
  }));
  $$('[data-bzf-q4]').forEach(b => b.addEventListener('click', () => {
    $$('[data-bzf-q4]').forEach(x => x.setAttribute('aria-checked','false'));
    b.setAttribute('aria-checked','true');
    state.answers.q4 = b.dataset.use;
    track('bzf_step_answered', { step: 'q4', value: b.dataset.use, time_on_step_ms: timeOnStepMs() });
    pulseAndAdvance(b, 380);
  }));

  $$('[data-bzf-open]').forEach(b => b.addEventListener('click', openModal));
  $('[data-bzf-back]').addEventListener('click', back);
  $('[data-bzf-close]').addEventListener('click', closeModal);
  $('[data-bzf-restart]').addEventListener('click', () => {
    track('bzf_restart_clicked', { from_primary: state.primary, from_secondary: state.secondary });
    state.history = [];
    state.answers = {q1:null,q2:null,q3:null,q4:null};
    state.primary = state.secondary = null;
    state.upsellAdded = false;
    $$('[aria-checked="true"]').forEach(b => b.setAttribute('aria-checked','false'));
    goTo('q1', false);
  });
  // Upsell "+ Aggiungi la seconda tonalità" · sets upsellAdded
  const upsellAdd = $('[data-bzf-upsell-add]');
  if (upsellAdd) upsellAdd.addEventListener('click', () => {
    track('bzf_upsell_added', { original_q4: state.answers.q4, primary: state.primary, secondary: state.secondary });
    state.upsellAdded = true;
    renderResult();
  });

  // Subscription CTA · drives Kaching to SINGLE offer + recommended shade + subscribe
  // toggle, then closes modal. Shown only in the B6-edge single case where the
  // subscription is the recommended path. (Previously only touched the .pdp-bundle
  // display and never drove the Kaching widget → it stayed on the default duo bar
  // with shade 1N — the reported bug.)
  const subCtaBtn = $('[data-bzf-sub-cta]');
  if (subCtaBtn) subCtaBtn.addEventListener('click', () => {
    track('bzf_subscription_cta_clicked', { primary: state.primary });
    const code = state.primary;
    const name = data.shadeNames[code] || code;
    const num = data.shadeNumber[code] || '?';
    // Write cart attribution (subscription mode)
    writeCartAttribution({
      primary: state.primary,
      secondary: state.secondary,
      mode: 'subscription',
      q4: state.answers.q4,
      via_upsell: state.upsellAdded
    });
    // Drive Kaching: single offer bar + recommended shade + subscribe toggle ON
    selectKachingBundle({
      primary: state.primary,
      secondary: state.secondary,
      isBundle: false,
      q4: state.answers.q4,
      subscribe: true
    });
    $$('.pdp-bundle').forEach(r => r.classList.remove('is-selected'));
    const target = document.querySelector('[data-bundle="sub"]') || document.querySelector('[data-bundle="single"]');
    if (target) {
      target.classList.add('is-selected');
      const v = target.querySelector('[data-bundle-variant]');
      if (v) v.textContent = '#' + num + ' ' + name + ' · ' + (LOCALE === 'en' ? 'every 60 days' : 'ogni 60 giorni');
    }
    closeModal();
    setTimeout(() => {
      const t = document.querySelector('.bzf-trigger-mini') || document.querySelector('.bzf-trigger');
      if (t) t.scrollIntoView({behavior:'smooth', block:'start'});
    }, 250);
  });

  // Shade code → Kaching variant full name (matches product option values)
  // Kaching option data-value = full variant name (code + name) on the product.
  // IT product uses IT names; UK/EU EN products use EN names (variants renamed).
  // Must match the dropdown's data-value exactly per market.
  const KACHING_SHADE_NAMES = LOCALE === 'en' ? {
    '1N': '1N Natural Fair',
    '1C': '1C Porcelain (Cool)',
    '2W': '2W Warm Beige',
    '2N': '2N Natural Beige',
    '3N': '3N Sun Beige',
    '3W': '3W Warm Gold',
    '4W': '4W Amber',
    '4C': '4C Bronze (Cool)',
    '5W': '5W Deep Caramel',
    '6N': '6N Chocolate'
  } : {
    '1N': '1N Chiaro Naturale',
    '1C': '1C Chiaro Freddo (Porcellana)',
    '2W': '2W Chiaro Caldo (Beige Dorato)',
    '2N': '2N Beige Naturale',
    '3N': '3N Beige Solare',
    '3W': '3W Dorato Caldo',
    '4W': '4W Ambrato',
    '4C': '4C Bronzo Freddo',
    '5W': '5W Caramello Intenso',
    '6N': '6N Cioccolato'
  };

  // Promisified delay
  function bzfDelay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Open a Kaching combobox + click the option matching the given shade name
  async function setKachingVariant(combo, shadeName) {
    if (!combo || !shadeName) return false;
    try {
      combo.focus();
      const r = combo.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      ['pointerdown','mousedown','mouseup','click'].forEach(function (t) {
        combo.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window, clientX: cx, clientY: cy, button: 0, buttons: 1 }));
      });
      // Poll for the listbox + its options to render. The Kaching swatch dropdown
      // lazy-renders on open and can take 300-400ms on first open — a fixed 180ms
      // wait misses it (first shade never selected). Poll up to ~1.2s instead.
      const listboxId = combo.getAttribute('aria-controls');
      let listbox = null;
      let opts = [];
      for (let attempt = 0; attempt < 15; attempt++) {
        await bzfDelay(80);
        listbox = listboxId ? document.getElementById(listboxId) : null;
        if (listbox) {
          opts = listbox.querySelectorAll('[role="option"], .kaching-bundles__swatch-dropdown__option, [data-value]');
          if (opts.length) break;
        }
      }
      if (!listbox || !opts.length) {
        combo.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
        return false;
      }
      let target = null;
      for (let i = 0; i < opts.length; i++) {
        const v = opts[i].getAttribute('data-value');
        if (v === shadeName || opts[i].textContent.trim() === shadeName) { target = opts[i]; break; }
      }
      if (!target) {
        // Close dropdown if option missing
        combo.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
        return false;
      }
      const tr = target.getBoundingClientRect();
      ['pointerdown','mousedown','mouseup','click'].forEach(function (t) {
        target.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window, clientX: tr.left + tr.width/2, clientY: tr.top + tr.height/2, button: 0, buttons: 1 }));
      });
      await bzfDelay(120);
      return true;
    } catch (e) {
      console.warn('bzf setKachingVariant:', e && e.message);
      return false;
    }
  }

  // Toggle the Kaching subscription group (subscribe vs one-time purchase).
  // Kaching renders a separate `.kaching-bundles__subscriptions` bar group with
  // 2 bars: [0] = subscribe & save, [1] = one-time. Bars have no radio — the DIV
  // itself is clickable and toggles `--selected`. Pass subscribe=true to subscribe.
  function selectKachingSubscriptionToggle(subscribe) {
    try {
      const subGroup = document.querySelector('.kaching-bundles__subscriptions');
      if (!subGroup) return false;
      const subBars = subGroup.querySelectorAll('.kaching-bundles__bar');
      if (subBars.length < 2) return false;
      const target = subscribe ? subBars[0] : subBars[1];
      if (target.classList.contains('kaching-bundles__bar--selected')) return true;
      const r = target.getBoundingClientRect();
      ['pointerdown','mousedown','mouseup','click'].forEach(function (t) {
        target.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window, clientX: r.left + r.width/2, clientY: r.top + r.height/2, button: 0, buttons: 1 }));
      });
      return true;
    } catch (e) {
      console.warn('bzf selectKachingSubscriptionToggle:', e && e.message);
      return false;
    }
  }

  // Slot ordering · MUST match renderResult() pick/extra logic so Kaching dropdowns
  // align with the result reveal + PDP bundle line.
  //   q4='abbronzata' (normal)        → pick = secondary (tanned)    · extra = primary
  //   q4='abbronzata' + secLighter    → pick = primary  (6N max)     · extra = secondary (lighter)
  //   q4='entrambe' / 'naturale'      → pick = primary               · extra = secondary
  function resolveKachingShades(meta) {
    const primaryFull   = KACHING_SHADE_NAMES[meta.primary]   || meta.primary;
    const secondaryFull = KACHING_SHADE_NAMES[meta.secondary] || meta.secondary;
    const hasTrue    = meta.secondary && meta.secondary !== meta.primary;
    const secLighter = hasTrue && parseInt(String(meta.secondary)[0], 10) < parseInt(String(meta.primary)[0], 10);
    const isAbbPickSec = meta.q4 === 'abbronzata' && hasTrue && !secLighter;
    return {
      firstShade:  isAbbPickSec ? secondaryFull : primaryFull,
      secondShade: (isAbbPickSec ? primaryFull : secondaryFull) || primaryFull
    };
  }

  // Guard flag: our own synthetic clicks must not be mistaken for user shade picks.
  let bzfApplyingShades = false;
  // Last quiz outcome driven into Kaching — used to re-apply when the customer
  // switches to a different offer bar after the quiz.
  let bzfLastKachingMeta = null;

  // Apply the recommended shades to EVERY variant dropdown of one offer bar.
  // Slot 0 → firstShade · slot 1 → secondShade · slot 2+ alternates (first/second).
  // Never fights the user: callers must skip bars flagged data-bzf-user.
  async function applyShadesToBarDropdowns(bar, shades) {
    if (bzfApplyingShades) return false; // re-entry guard: never two concurrent applies
    const dropdowns = bar.querySelectorAll('.kaching-bundles__bar-variant-select[role="combobox"]');
    if (!dropdowns.length) return false;
    bzfApplyingShades = true;
    try {
      for (let i = 0; i < dropdowns.length; i++) {
        const want = i === 0 ? shades.firstShade
                   : i === 1 ? shades.secondShade
                   : (i % 2 === 0 ? shades.firstShade : shades.secondShade);
        if (!want) continue;
        // No-op if the combobox already displays the wanted shade (also makes
        // repeated calls cheap — no stale "applied" stamp that can lie after
        // a Kaching re-render).
        const cur = (dropdowns[i].textContent || '').trim();
        if (cur.indexOf(want) !== -1) continue;
        await setKachingVariant(dropdowns[i], want);
      }
      return true;
    } finally {
      bzfApplyingShades = false;
    }
  }

  // Persistent safety net: if the customer switches to ANOTHER Kaching offer bar
  // after finishing the quiz, apply the recommended shade(s) there too — the
  // recommendation must follow them across every offer. A bar where the customer
  // manually picked a shade (data-bzf-user) is never overridden.
  let bzfKachingPersistInstalled = false;
  function installKachingPersistence() {
    if (bzfKachingPersistInstalled) return;
    bzfKachingPersistInstalled = true;
    document.addEventListener('click', function (e) {
      try {
        if (bzfApplyingShades || !bzfLastKachingMeta) return;
        if (!e.target || !e.target.closest) return;
        // Ignore the subscription toggle group entirely
        if (e.target.closest('.kaching-bundles__subscriptions')) return;
        // Customer interacting with a shade dropdown → that bar is theirs now.
        const combo = e.target.closest('.kaching-bundles__bar-variant-select, [class*="swatch-dropdown"]');
        if (combo) {
          const ownBar = combo.closest('.kaching-bundles__bar');
          if (ownBar) ownBar.setAttribute('data-bzf-user', '1');
          return;
        }
        // Customer clicked an offer bar → after Kaching renders its dropdowns, apply
        // shades. A freshly-selected bar's dropdowns can take 300-900ms to render, so
        // poll for them (up to ~2.5s) before applying instead of a single fixed wait.
        const bar = e.target.closest('.kaching-bundles__bar');
        if (!bar || bar.getAttribute('data-bzf-user')) return;
        const shades = resolveKachingShades(bzfLastKachingMeta);
        let tries = 0;
        (function waitAndApply() {
          if (bar.getAttribute('data-bzf-user')) return; // customer took over meanwhile
          const combo = bar.querySelector('.kaching-bundles__bar-variant-select[role="combobox"]');
          if (combo && combo.offsetParent !== null) { applyShadesToBarDropdowns(bar, shades); return; }
          if (++tries > 12) return;
          setTimeout(waitAndApply, 200);
        })();
      } catch (err) { /* never break the page */ }
    }, true);
  }

  // Select the right Kaching bundle bar + variants based on quiz outcome.
  // meta.subscribe (bool) → also toggle the subscription group accordingly.
  // The recommended shade is applied to ALL offer bars (not just the target one),
  // so whichever offer the customer ends up choosing already carries their shade.
  async function selectKachingBundle(meta) {
    try {
      // Offer bars live in the FIRST .kaching-bundles__bars group; the subscription
      // toggle is a separate .kaching-bundles__subscriptions group. Scope to offers
      // so bar indices (0=single, 1=duo, 2=triple) are not polluted by sub bars.
      const offerGroup = document.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions)');
      const bars = offerGroup
        ? offerGroup.querySelectorAll('.kaching-bundles__bar')
        : document.querySelectorAll('.kaching-bundles__bar');
      if (!bars.length) return false;
      bzfLastKachingMeta = meta;
      installKachingPersistence();
      const shades = resolveKachingShades(meta);
      // Bar 0 = single, bar 1 = bundle (Kit Pelle Uniforme)
      const targetBar = meta.isBundle && bars.length >= 2 ? bars[1] : bars[0];

      // PASS 1 · best-effort pre-fill of every OTHER offer bar whose dropdowns are
      // already rendered/visible. Done BEFORE selecting the target bar so any bar
      // Kaching auto-selects as a side effect gets corrected by pass 2.
      for (let i = 0; i < bars.length; i++) {
        if (bars[i] === targetBar || bars[i].getAttribute('data-bzf-user')) continue;
        const dd = bars[i].querySelectorAll('.kaching-bundles__bar-variant-select[role="combobox"]');
        if (dd.length && dd[0].offsetParent !== null) {
          await applyShadesToBarDropdowns(bars[i], shades);
        }
      }

      // PASS 2 · select the target bar and fill its dropdowns.
      const radio = targetBar.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        try { radio.click(); } catch (e) {}
        await bzfDelay(220);
      }
      await applyShadesToBarDropdowns(targetBar, shades);

      // Apply subscription toggle ONLY when the quiz explicitly recommends it
      // (B6-edge sub CTA). For the normal CTA we leave Kaching's own default
      // subscribe/one-time state untouched — that default is a merchant pricing
      // strategy decision, not something the quiz should override.
      if (meta.subscribe === true) selectKachingSubscriptionToggle(true);
      return true;
    } catch (e) {
      console.warn('bzf selectKachingBundle:', e && e.message);
      return false;
    }
  }

  // Write quiz attribution to Shopify cart attributes
  // → order.note_attributes → CF Worker webhook → bzf_purchase event in PostHog
  function writeCartAttribution(meta) {
    if (typeof fetch === 'undefined') return Promise.resolve();
    var did = '';
    try { did = (typeof posthog !== 'undefined' && posthog.get_distinct_id) ? posthog.get_distinct_id() : ''; } catch (e) {}
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          bzf_distinct_id:   did,
          bzf_primary:       meta.primary || '',
          bzf_secondary:     meta.secondary || '',
          bzf_mode:          meta.mode || '',
          bzf_q4:            meta.q4 || '',
          bzf_via_upsell:    meta.via_upsell ? 'true' : 'false',
          bzf_completed_at:  new Date().toISOString()
        }
      })
    }).catch(function (e) { console.warn('bzf cart attribution failed:', e); });
  }

  $('[data-bzf-cta]').addEventListener('click', () => {
    const q4 = state.answers.q4;
    const hasTrueSecondary = state.secondary && state.secondary !== state.primary;
    const isBundle = (q4 === 'entrambe' || state.upsellAdded) && hasTrueSecondary;
    track('bzf_cta_clicked', {
      mode: isBundle ? 'bundle' : 'single',
      q4, primary: state.primary, secondary: state.secondary,
      via_upsell: state.upsellAdded,
      session_duration_ms: state.sessionStartTs ? Date.now() - state.sessionStartTs : 0
    });
    // Write quiz context to cart attributes (fire-and-forget, no UI block)
    writeCartAttribution({
      primary: state.primary,
      secondary: state.secondary,
      mode: isBundle ? 'bundle' : 'single',
      q4: q4,
      via_upsell: state.upsellAdded
    });
    // Auto-select Kaching bundle bar + variants (fire-and-forget, async).
    // No subscribe flag → leaves Kaching's default subscribe/one-time state as-is.
    selectKachingBundle({
      primary: state.primary,
      secondary: state.secondary,
      isBundle: isBundle,
      q4: q4
    });
    // Pick/extra resolution · MUST match renderResult() & selectKachingBundle()
    //   q4='abbronzata' normal      → pick = secondary, extra = primary
    //   q4='abbronzata' + secLighter→ pick = primary (max), extra = secondary (lighter)
    //   else                         → pick = primary, extra = secondary
    const secLighterCta = hasTrueSecondary && parseInt(state.secondary[0], 10) < parseInt(state.primary[0], 10);
    const ctaIsAbbPickSec = q4 === 'abbronzata' && hasTrueSecondary && !secLighterCta;
    const pickCode  = ctaIsAbbPickSec ? state.secondary : state.primary;
    const extraCode = ctaIsAbbPickSec ? state.primary   : state.secondary;
    const pickName  = data.shadeNames[pickCode]   || pickCode;
    const pickNum   = data.shadeNumber[pickCode]  || '?';
    const extraName = data.shadeNames[extraCode]  || extraCode;
    const extraNum  = data.shadeNumber[extraCode] || '?';
    $$('.pdp-bundle').forEach(r => r.classList.remove('is-selected'));
    const target = isBundle ? document.querySelector('[data-bundle="duo"]') : document.querySelector('[data-bundle="single"]');
    if (target) {
      target.classList.add('is-selected');
      const v = target.querySelector('[data-bundle-variant]');
      if (v) {
        if (isBundle) {
          v.textContent = '#' + pickNum + ' ' + pickName + ' + #' + extraNum + ' ' + extraName;
        } else {
          v.textContent = '#' + pickNum + ' ' + pickName;
        }
      }
    }
    closeModal();
    setTimeout(() => {
      const t = document.querySelector('.bzf-trigger-mini') || document.querySelector('.bzf-trigger');
      if (t) t.scrollIntoView({behavior:'smooth', block:'start'});
    }, 250);
  });

  $$('.pdp-bundle').forEach(r => r.addEventListener('click', () => {
    $$('.pdp-bundle').forEach(x => x.classList.remove('is-selected'));
    r.classList.add('is-selected');
    track('bzf_bundle_row_clicked', { bundle_type: r.dataset.bundle });
  }));
  const pdpCta = document.querySelector('.pdp-cta');
  if (pdpCta) pdpCta.addEventListener('click', () => {
    const sel = document.querySelector('.pdp-bundle.is-selected');
    track('bzf_pdp_addtocart_clicked', { bundle_type: sel ? sel.dataset.bundle : null });
  });

  function computeShades() {
    const b = state.answers.q1, u = state.answers.q2, r = state.answers.q3;
    if (!b || !u) return;
    const m = data.shadeMatch[b];
    state.primary = m ? m[u] : null;
    const bInt = parseInt(b, 10);
    if (r !== null && data.tanShift[r] !== undefined) {
      const shift = data.tanShift[r];
      const tanBucket = Math.min(6, bInt + shift);
      const tT = data.shadeMatch[String(tanBucket)];
      state.secondary = tT ? tT[u] : state.primary;
    } else {
      state.secondary = state.primary;
    }
    // Fallback ALWAYS · garantisce sempre due tonalità distinte per upsell/bundle
    // (B6 max scura · B1·W low sun · qualunque combo dove secondary == primary)
    if (state.secondary === state.primary) {
      const up2 = data.shadeMatch[String(Math.min(6, bInt + 2))];
      if (up2 && up2[u] && up2[u] !== state.primary) {
        state.secondary = up2[u];
      } else {
        const down1 = data.shadeMatch[String(Math.max(1, bInt - 1))];
        if (down1 && down1[u] && down1[u] !== state.primary) {
          state.secondary = down1[u];
        }
      }
    }
  }
  // helper · true if secondary code is a LIGHTER bucket than primary
  function secondaryIsLighter() {
    if (!state.primary || !state.secondary) return false;
    return parseInt(state.secondary[0], 10) < parseInt(state.primary[0], 10);
  }

  function renderResult() {
    const q4 = state.answers.q4;
    const primaryCode = state.primary;
    const hasTrueSecondary = state.secondary && state.secondary !== state.primary;
    const secondaryCode = hasTrueSecondary ? state.secondary : null;
    // Bundle = (entrambe OR user added via upsell) + true secondary
    const fromUpsell = state.upsellAdded && q4 !== 'entrambe';
    const isBundle = ((q4 === 'entrambe') || state.upsellAdded) && hasTrueSecondary;

    // Reveal · user's pick first
    const reveal = $('[data-bzf-result-reveal]');
    if (reveal) {
      const pick = (q4 === 'abbronzata' && hasTrueSecondary) ? secondaryCode : primaryCode;
      const extra = (q4 === 'abbronzata' && hasTrueSecondary) ? primaryCode : secondaryCode;
      if (isBundle) reveal.textContent = (data.shadeNames[pick] || pick) + ' + ' + (data.shadeNames[extra] || extra);
      else reveal.textContent = data.shadeNames[pick] || pick || '—';
    }

    // Shade rows · primary = user's actual pick · added = second one (X to remove)
    const wrap = $('[data-bzf-result-shades]');
    while (wrap.firstChild) wrap.removeChild(wrap.firstChild);

    // Determine which is "their pick" vs "extra"
    const secLighter = hasTrueSecondary && secondaryIsLighter();
    let pickCode, extraCode, pickCopy, extraCopy;
    if (q4 === 'abbronzata' && hasTrueSecondary && !secLighter) {
      // normal: secondary is warmer/darker · use as their tan pick
      pickCode = secondaryCode;
      pickCopy = T('pick_copy_tan_normal');
      extraCode = primaryCode;
      extraCopy = T('pick_copy_natural_off');
    } else if (q4 === 'abbronzata' && hasTrueSecondary && secLighter) {
      // edge · max bucket abbronzata · pick stays primary (no darker possible) · extra is lighter
      pickCode = primaryCode;
      pickCopy = T('pick_copy_max_dark');
      extraCode = secondaryCode;
      extraCopy = T('pick_copy_lighter_off');
    } else {
      // naturale + entrambe
      pickCode = primaryCode;
      pickCopy = secLighter ? T('pick_copy_lighter_max') : T('pick_copy_daily');
      extraCode = secondaryCode;
      extraCopy = secLighter ? T('extra_copy_lighter') : T('extra_copy_warmer');
    }

    if (isBundle) {
      wrap.appendChild(buildShadeRow(pickCode, pickCopy, { variant: 'primary', tag: T('tag_recommended') }));
      let addedTag;
      if (secLighter) {
        addedTag = (q4 === 'entrambe' && !fromUpsell) ? T('tag_second_lighter') : T('tag_for_off_days');
      } else {
        addedTag = (q4 === 'entrambe' && !fromUpsell) ? T('tag_second_tan') : T('tag_for_tan_you');
      }
      wrap.appendChild(buildShadeRow(extraCode, extraCopy, { variant: 'added', tag: addedTag, removable: fromUpsell }));
    } else {
      wrap.appendChild(buildShadeRow(pickCode, pickCopy, { variant: 'primary', tag: T('tag_recommended') }));
    }

    // Bundle why · direction-aware copy
    const wb = $('[data-bzf-why-bundle]'), wbt = $('[data-bzf-why-bundle-text]');
    if (isBundle && secondaryCode) {
      wb.hidden = false;
      wbt.textContent = secLighter ? T('bundle_why_lighter') : T('bundle_why_warmer');
    } else { wb.hidden = true; }

    // CTA copy · NO PRICE · Kabuki gift framing · dynamic pulse on change
    const ctaLabel = $('[data-bzf-cta-label]'), ctaSub = $('[data-bzf-cta-sub]');
    const ctaBtn = $('[data-bzf-cta]');
    const newLabel = isBundle ? T('cta_bundle') : T('cta_single');
    let newSub;
    if (isBundle) {
      newSub = T('cta_bundle_sub');
    } else if (secLighter) {
      // B6 edge · subscription is the recommended path
      newSub = T('cta_single_sub_b6');
    } else {
      newSub = T('cta_single_sub');
    }
    if (ctaLabel.textContent !== newLabel) {
      ctaLabel.textContent = newLabel;
      ctaSub.textContent = newSub;
      if (ctaBtn) {
        ctaBtn.classList.remove('is-updated');
        // force reflow then re-add
        void ctaBtn.offsetWidth;
        ctaBtn.classList.add('is-updated');
        setTimeout(() => ctaBtn.classList.remove('is-updated'), 600);
      }
    } else {
      ctaSub.textContent = newSub;
    }

    // Subscription block · BUNDLE always · ALSO when B6-edge (secLighter · max bucket)
    const sub = $('[data-bzf-subscription]');
    const subEyebrow = $('[data-bzf-sub-eyebrow]');
    const subHead = $('[data-bzf-sub-head]');
    const subCta = $('[data-bzf-sub-cta]');
    const showSub = isBundle || secLighter;
    if (sub) sub.hidden = !showSub;
    if (showSub) {
      if (secLighter && !isBundle) {
        // B6-edge single · subscription IS the recommendation
        const pickName = data.shadeNames[primaryCode] || primaryCode;
        subEyebrow.textContent = T('sub_eyebrow_b6');
        subHead.textContent = T('sub_head_b6_prefix') + pickName + T('sub_head_b6_suffix');
        if (subCta) subCta.hidden = false;
      } else {
        // standard bundle subscription pitch (incl. B6 entrambe · they chose 2)
        subEyebrow.textContent = T('sub_eyebrow_default');
        subHead.textContent = T('sub_head_default');
        if (subCta) subCta.hidden = true;
      }
    }

    // Upsell pair · hide when isBundle OR no real secondary OR B6-edge (sub replaces it)
    const ups = $('[data-bzf-upsell]');
    if (!isBundle && hasTrueSecondary && !secLighter) {
      ups.hidden = false;
      const isAbbronzata = q4 === 'abbronzata';
      // pick/extra direction matches the row logic above
      const pickUp = (isAbbronzata && !secLighter) ? secondaryCode : primaryCode;
      const extraUp = (isAbbronzata && !secLighter) ? primaryCode : secondaryCode;

      let headTxt, bodyTxt;
      if (secLighter) {
        // downshift case (B6 anything)
        headTxt = T('upsell_head_downshift');
        bodyTxt = T('upsell_body_downshift');
      } else if (isAbbronzata) {
        headTxt = T('upsell_head_abbronzata');
        bodyTxt = T('upsell_body_abbronzata');
      } else {
        headTxt = T('upsell_head_default');
        bodyTxt = T('upsell_body_default');
      }
      $('[data-bzf-upsell-head]').textContent = headTxt;
      $('[data-bzf-upsell-text]').textContent = bodyTxt;

      const upsellShades = $('[data-bzf-upsell-shades]');
      while (upsellShades.firstChild) upsellShades.removeChild(upsellShades.firstChild);
      upsellShades.appendChild(buildMiniShade(pickUp));
      upsellShades.appendChild(buildMiniShade(extraUp));
    } else {
      ups.hidden = true;
    }
  }

  function buildShadeRow(code, copy, opts) {
    opts = opts || {};
    const hex = data.shadeHex[code] || '#C68754';
    const num = data.shadeNumber[code] || '?';
    const name = data.shadeNames[code] || code;
    const row = document.createElement('div');
    row.className = 'bzf-result__shade';
    if (opts.variant === 'primary') row.classList.add('bzf-result__shade--primary');
    if (opts.variant === 'added') row.classList.add('bzf-result__shade--added');
    // swatch
    const swEl = document.createElement('div'); swEl.className = 'bzf-result__shade-swatch'; swEl.style.background = hex;
    // body
    const body = document.createElement('div');
    if (opts.tag) {
      const tag = document.createElement('p'); tag.className = 'bzf-result__shade-tag'; tag.textContent = opts.tag;
      body.appendChild(tag);
    }
    const cd = document.createElement('p'); cd.className = 'bzf-result__shade-code'; cd.textContent = '#' + num + ' · ' + code;
    const nm = document.createElement('h3'); nm.className = 'bzf-result__shade-name'; nm.textContent = name;
    const cp = document.createElement('p'); cp.className = 'bzf-result__shade-copy'; cp.textContent = copy;
    body.appendChild(cd); body.appendChild(nm); body.appendChild(cp);
    row.appendChild(swEl); row.appendChild(body);
    // removable X button
    if (opts.removable) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bzf-result__shade-remove';
      btn.setAttribute('aria-label', T('remove_aria'));
      btn.title = T('remove_title');
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M6 6l12 12M18 6L6 18');
      svg.appendChild(path);
      btn.appendChild(svg);
      btn.addEventListener('click', () => {
        track('bzf_upsell_removed', { primary: state.primary, secondary: state.secondary, q4: state.answers.q4 });
        state.upsellAdded = false;
        renderResult();
      });
      row.appendChild(btn);
    } else {
      // placeholder to maintain grid columns
      const ph = document.createElement('span'); ph.setAttribute('aria-hidden', 'true');
      row.appendChild(ph);
    }
    return row;
  }
  function buildMiniShade(code) {
    const hex = data.shadeHex[code] || '#C68754';
    const num = data.shadeNumber[code] || '?';
    const name = data.shadeNames[code] || code;
    const cell = document.createElement('div');
    cell.className = 'bzf-result__upsell-shade';
    const sw = document.createElement('div'); sw.className = 'bzf-result__upsell-swatch'; sw.style.background = hex;
    const info = document.createElement('div'); info.className = 'bzf-result__upsell-shade-info';
    const cd = document.createElement('div'); cd.className = 'bzf-result__upsell-shade-code'; cd.textContent = '#' + num + ' · ' + code;
    const nm = document.createElement('div'); nm.className = 'bzf-result__upsell-shade-name'; nm.textContent = name;
    info.appendChild(cd); info.appendChild(nm);
    cell.appendChild(sw); cell.appendChild(info);
    return cell;
  }

  updateProgress(); updateBackButton();

  // ─── Mini trigger · swatch + label color cycle every 450ms · text darkened for contrast ───
  (function cycleTriggerSwatch() {
    const sw = document.querySelector('[data-bzf-trigger-swatch]');
    const label = document.querySelector('.bzf-trigger-mini__label');
    if (!sw) return;
    const codes = Object.keys(data.shadeHex);
    // darken helper · ensures text stays readable on white bg
    function darken(hex, amount) {
      const r = Math.max(0, Math.round(parseInt(hex.substr(1,2), 16) * (1 - amount)));
      const g = Math.max(0, Math.round(parseInt(hex.substr(3,2), 16) * (1 - amount)));
      const b = Math.max(0, Math.round(parseInt(hex.substr(5,2), 16) * (1 - amount)));
      const toHex = n => n.toString(16).padStart(2, '0');
      return '#' + toHex(r) + toHex(g) + toHex(b);
    }
    // shade-specific darken: lighter shades darkened more (for contrast on white)
    function textColor(hex) {
      const r = parseInt(hex.substr(1,2), 16);
      const g = parseInt(hex.substr(3,2), 16);
      const b = parseInt(hex.substr(5,2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      // luminance 0..1 · light shades → darken more · dark shades → light touch
      const amount = luminance > 0.65 ? 0.55 : luminance > 0.5 ? 0.4 : luminance > 0.35 ? 0.25 : 0.1;
      return darken(hex, amount);
    }
    let i = 0;
    function apply() {
      const hex = data.shadeHex[codes[i]];
      sw.style.background = hex;
      if (label) label.style.color = textColor(hex);
    }
    apply();
    setInterval(() => {
      i = (i + 1) % codes.length;
      apply();
    }, 450);
  })();

  // ─── RALPH LOOP · auto-test all combinations + slot resolution ───
  // Run window.bzfTest() in console to verify all paths
  window.bzfTest = function () {
    const bugs = [];
    const buckets = ['1','2','3','4','5','6'];
    const undertones = ['C','W','N'];
    const suns = ['0','1','2','3'];
    const uses = ['entrambe','naturale','abbronzata'];
    const upsellStates = [false, true];
    let cases = 0;
    for (const b of buckets) for (const u of undertones) for (const s of suns) for (const q of uses) for (const ups of upsellStates) {
      cases++;
      state.answers = {q1:b, q2:u, q3:s, q4:q};
      state.upsellAdded = ups;
      computeShades();
      const pri = state.primary, sec = state.secondary;
      const hasTrue = sec && sec !== pri;
      const tag = `${b}/${u}/${s}/${q}/ups=${ups}`;

      // Coverage checks
      if (!pri) bugs.push(`${tag}: primary undefined`);
      if (!data.shadeNames[pri]) bugs.push(`${tag}: shadeNames missing for ${pri}`);
      if (!data.shadeHex[pri]) bugs.push(`${tag}: shadeHex missing for ${pri}`);
      if (!data.shadeNumber[pri]) bugs.push(`${tag}: shadeNumber missing for ${pri}`);
      if (sec && !data.shadeNames[sec]) bugs.push(`${tag}: shadeNames missing for sec ${sec}`);
      if (sec && !data.shadeHex[sec]) bugs.push(`${tag}: shadeHex missing for sec ${sec}`);

      // Render & ensure no exception
      try { goTo('result', false); }
      catch (e) { bugs.push(`${tag}: render threw ${e.message}`); }

      // Slot resolution invariants · pick/extra must match across renderResult + Kaching + PDP
      const secLighter = hasTrue && parseInt(sec[0], 10) < parseInt(pri[0], 10);
      const isBundle = ((q === 'entrambe') || ups) && hasTrue;
      const isAbbPickSec = q === 'abbronzata' && hasTrue && !secLighter;
      const pick = isAbbPickSec ? sec : pri;
      const extra = isAbbPickSec ? pri : sec;

      // 1. pick must be a known shade
      if (pick && !data.shadeNames[pick]) bugs.push(`${tag}: pick ${pick} not in shadeNames`);
      // 2. when bundle, slots MUST differ
      if (isBundle && pick === extra) bugs.push(`${tag}: bundle slots identical (${pick} = ${extra})`);
      // 3. when bundle, extra must exist
      if (isBundle && !extra) bugs.push(`${tag}: bundle missing extra`);
      // 4. abbronzata + hasTrue normal → pick should equal secondary
      if (q === 'abbronzata' && hasTrue && !secLighter && pick !== sec) {
        bugs.push(`${tag}: abbronzata-normal pick should be secondary ${sec} but got ${pick}`);
      }
      // 5. abbronzata + secLighter (B6 edge) → pick should stay primary
      if (q === 'abbronzata' && hasTrue && secLighter && pick !== pri) {
        bugs.push(`${tag}: abbronzata-secLighter pick should be primary ${pri} but got ${pick}`);
      }
      // 6. entrambe / naturale → pick should equal primary
      if ((q === 'entrambe' || q === 'naturale') && pick !== pri) {
        bugs.push(`${tag}: ${q} pick should be primary ${pri} but got ${pick}`);
      }
    }
    state.upsellAdded = false;
    console.log(`[Ralph] tested ${cases} combos · ${bugs.length} bug(s)`);
    bugs.forEach(b => console.warn('[Ralph]', b));
    return { cases, bugs };
  };
})();